import React from 'react'
import { compose, withState } from 'recompose'
import { Dropdown } from 'semantic-ui-react'

const SelectInput = (props) => {
  const { 
    label, 
    placeHolder, 
    input, 
    require, 
    editable=true,
    loading, 
    multiple,
    noBorder,
    allowAdditions, 
    onAddNewItem,
    specialOnChange, 
    options=[], 
    ignoreClearValue, 
    specialOnSearchChange,
    specialOnClose,
    underLabel=null,
    searchQuery, 
    setSearchQuery, 
    beforeOnChange, 
    noResultsMessage, 
    useLazyLoad=false, 
    style, 
    meta: { touched, error } 
  } = props

  const [searchKey, setSearchKey] = React.useState(0)

  const getDataOption = React.useMemo(() => {
    if(!useLazyLoad) return ()=>options
    return ()=>{
      if(options.length>0){
        if(searchKey==''){
          let data = options.filter((x,i)=>i<50)
          if(input.value){
            if(!data.find((x)=>x.value==input.value)){
              let i = options.find((x)=>x.value==input.value)
              if(i!=null) data.push(i)
            }
          }
          return data
        }
        else{
          let searchResult = options.filter((x)=>x.text.includes(searchKey))
          return searchResult.filter((x,i)=>i<50)
        }
      }
    }
  }, [searchKey,options,input.value])

  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`fieldInput ${editable!==false?'editableSelectInput':'disableSelectInput'} ${noBorder?'selectInputNoBorder':''}`}>
        <Dropdown
          name={input.name}
          fluid
          search
          selection
          selectOnBlur={false}
          clearable={editable && !ignoreClearValue}
          disabled={editable === false}
          placeholder={placeHolder}
          additionPosition='bottom'
          error={touched && error}
          value={input.value}
          options={getDataOption()}
          multiple={multiple !== undefined ? multiple : false}
          allowAdditions={allowAdditions !== undefined ? allowAdditions : false}
          loading={loading !== undefined ? loading : false}
          noResultsMessage={noResultsMessage ? noResultsMessage : 'No results found.'}
          onChange={(e, data) => {
            setSearchKey(data.value)
            if (beforeOnChange) {
              beforeOnChange({
                value: data.value,
                onChange: () => {
                  input.onChange(data.value)
                  setSearchQuery('')
                },
                specialOnChange: specialOnChange ? () => specialOnChange(data.value) : null,
                clearSearchText: () => setSearchQuery('')
              })
            } else {
              input.onChange(data.value)
              setSearchQuery('')
              if (specialOnChange) {
                specialOnChange(data.value)
              }
            }
          }}
          onClose={(e, data) => {
            setSearchQuery('')
            setSearchKey('')
            if (specialOnClose) {
              specialOnClose(data)
            }
          }}
          onAddItem={(e, data) => {
            onAddNewItem(data.value)
          }}
          searchQuery={searchQuery}
          onSearchChange={(e, data) => {
            setSearchKey(data.searchQuery)
            if (searchQuery !== data.searchQuery.trimLeft()) {
              setSearchQuery(data.searchQuery.trimLeft())
              data.searchQuery = data.searchQuery.trim()
              if (specialOnSearchChange) {
                specialOnSearchChange(data.searchQuery)
              }
            }
          }}
        />
      </div>
      {underLabel?<span className='fieldLabel'>
        {underLabel}
      </span>:null}
    </div>
  )
}

export default compose(
  withState('searchQuery', 'setSearchQuery', '')
)(SelectInput)
